import React from "react";

import MaskedInput from "react-text-mask";
import InputLabel from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FormHelperText from "@material-ui/core/FormHelperText";

import useStyles from "../styles/textFieldStyle";

const MobileTextField = (props) => {
  const { form, field, label } = props;

  const classes = useStyles();

  let otherProps = {};

  if (form.errors[field.name] && form.touched[field.name]) {
    otherProps.helperText = form.errors[field.name];
    otherProps.error = true;
  }

  return (
    <React.Fragment>
      <InputLabel variant="outlined" style={{ marginTop: 0 }} {...otherProps}>
        {label}
      </InputLabel>
      <OutlinedInput
        onChange={(e) => {
          form.setFieldValue(field.name, e.target.value);
        }}
        label={label}
        variant="outlined"
        inputComponent={TextMaskCustom}
        required
        className={[classes.width100, classes.root]}
        {...otherProps}
      />

      {otherProps.error && (
        <FormHelperText {...otherProps}>{otherProps.helperText}</FormHelperText>
      )}
    </React.Fragment>
  );
};

const TextMaskCustom = (props) => {
  const { inputRef, ...other } = props;

  // prettier-ignore
  const mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
      placeholderChar={"\u2000"}
      showMask
      guide={false}
    />
  );
};

export default MobileTextField;



// WEBPACK FOOTER //
// ./src/components/MobileTextField.js